import React from "react";
import { useForm } from "react-hook-form";
import { states } from "../data/selectData";
import BtnTailwind from "./BtnTailwind";
import SelectTailwind from "./SelectTailwind";

export default function SearchForm({ getItems }) {
  const { register, handleSubmit } = useForm();
  const onSubmit = (data) => {
    console.log(data);
    getItems(data);
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="flex items-center flex-col md:flex-row justify evenly justify-around"
    >
      <SelectTailwind
        placeholder={"Estado"}
        options={states}
        width={20}
        register={register}
        registerName={"estado"}
      />
      <SelectTailwind
        register={register}
        registerName={"ramo"}
        placeholder={"Ramo de atuação"}
        options={[
          "instalação",
          "Projetos",
          "Assistência técnica (manutenção)",
          "processo de AVCB",
        ]}
      />
      <BtnTailwind type={"submit"} />
    </form>
  );
}
